<template>
  <aside class="main-sidebar">
    <!-- sidebar: style can be found in sidebar.less -->
    <div>
      <section class="sidebar">
        <!-- /.search form -->
        <!-- Sidebar user panel -->
        <div class="user-panel">
          <div class="image"><img :src=tx class="img-circle" alt="User Image"></div>
          <div class="info">
            <p style="font-size: 0.3rem" >{{userName}}</p>
            <p>
              <small v-if="departmentName">（{{departmentName}}）</small>
              <small v-else>（平台管理）</small>
            </p>
            <div><a href="#" @click="changePW"><i class="ti-panel"></i>
              <small>修改密码</small>
            </a> <a href="#" @click="logout"><i class="ti-power-off"></i>
              <small>退出</small>
            </a></div>
          </div>
          <img class="bg-user" src="/static/img/avatar-bg.png" alt="User Image"></div>
        <!-- sidebar menu: : style can be found in sidebar.less -->
        <ul class="sidebar-menu">
          <template v-for="levelOne in menuData.item">
            <li class="treeview" v-if="check(levelOne)">
              <a href="#">
                <i :class=levelOne.icon></i>
                <span>{{levelOne.title }}</span><span
                class="pull-right-container">
              <i class="fa fa-angle-left pull-right"></i>
            </span> </a>
              <ul class="treeview-menu">
                <template v-for="(levelTwo,index) in levelOne.item">
                  <li class="active" v-if="roles.indexOf(levelTwo.code) !== -1">
                    <router-link :to="{path: levelTwo.url}" replace>
                      <avatar :username=levelTwo.title :size='20' color="#fff" :backgroundColor=bgColor[index]></avatar>
                      {{levelTwo.title}}
                    </router-link>
                  </li>
                </template>
              </ul>
            </li>
          </template>
          <li class="header">版权所有 © 2021 广州市东迅公司</li>
          <li>
            <br>
            <br>
            <br>
          </li>
        </ul>
      </section>
      <!-- /.sidebar -->
    </div>
  </aside>
</template>

<script>
  import Avatar from 'vue-avatar'

  export default {
    name: 'DashboardSidebar',
    data: function () {
      let userInfo = this.$store.state.userInfo;
      // console.log(userInfo);
      return {
        staffName: userInfo.staffName,
        userName: userInfo.name,
        departmentName: userInfo.departmentName,
        menuData: {},
        roles: userInfo.roles,
        userType: userInfo.type,
        bgColor: ["#2196F3", "#673AB7", "#3F51B5", "#F44336", "#FF4081", "#9C27B0"],
        tx: userInfo.avatarUrl
      }
    },
    mounted: function () {
      if (this.userType === 'ORDINARY') {
        this.menuData = require('../../menu.json')
      } else {
        this.menuData = require('../../menu_school.json')
      }
      $(document).ready(function ($) {
        $('.main-sidebar > div').slimScroll({
          position: 'left',
          size: '3px',
          height: '95vh'
        })
      });
      // 解决菜单树缩小后， 设置宽度会遮蔽内容， 但不设置宽度又无法弹出选项的问题
      $('.sidebar-menu').hover(function () {
        $(".slimScrollDiv").css("width", "230px");
      }, function () {
        $(".slimScrollDiv").css("width", "auto");
      });
    },
    methods: {
      logout: function () {
        localStorage.removeItem("autoLogin");
        localStorage.removeItem("token");
        this.$store.commit("SET_LOGIN", false);
        this.$store.commit("SET_USERINFO", null);

        this.$store.state.dataTables = {}
        this.$router.replace('/')
      },
      changePW: function () {
        this.$router.replace('/password')
      },
      check: function (value) {
        let checkNum = 0;
        if (this.roles) {
          for (var x in value.item) {
            if (this.roles.indexOf(value.item[x].code) !== -1) {
              checkNum++
            }
          }
        }
        if (checkNum > 0) {
          return true
        } else {
          return false
        }
      }
    },
    components: {
      Avatar
    }
  }
</script>



// WEBPACK FOOTER //
// Sidebar.vue?1acb3977